import InfoDetails from 'components/InfoDetails';
import Separator from 'components/Separator';
import './miscInfo.scss'

const MiscInfo = ({ data }) => {

    const community_features = [
        "Fishing",
        "Fitness",
        "Park",
        "Playground",
        "Pool",
        "Sidewalk"
    ]

    const cooling_heating = [
        "Central",
        "Electric",
        "Heat Pump"
    ]

    const laundry_features = [
        "Inside",
        "Laundry Room"
    ]

    const window_features = []

    return (
        <div className='misc-info-container'>
            {
                data.community_features.length > 0 &&
                <InfoDetails title={'Community Features'} items={data.community_features} />
            }
            {
                data.cooling_heating.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Cooling / Heating'} items={data.cooling_heating} />
                </>
            }
            {
                data.laundry_features.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Laundry Features'} items={data.laundry_features} />
                </>
            }

            {
                (data.community_features.length === 0 && 
                data.cooling_heating.length === 0 && 
                data.laundry_features.length === 0) &&
                <div className='no-data'>
                    <p>No Miscellaneous Features</p>
                </div>
            }
        </div>
    )
}


export default MiscInfo;